var hashtag_default = {
  "fontElementMap": "ozM4f",
  "hashtag": "VzbI7"
};
export {
  hashtag_default as default
};
//# sourceMappingURL=hashtag-scss.js.map
